// extracted by css-extract-rspack-plugin
export default {"cls1":"TasteOfMentionsHeader-cls1_WUF","cls2":"TasteOfMentionsHeader-cls2_ezx TasteOfMentionsHeader-cls1_WUF"};